import { consola } from 'consola';
export const LOGGER = consola.create({
  level: 1,
});
